import React, { useState } from 'react';
import { Download, FileSpreadsheet, FileText as FileTextIcon, Loader2 } from 'lucide-react';
import api from '../../components/api';
import { toast } from 'react-toastify';

const ExportMenu = ({ showExportOptions, setShowExportOptions, searchTerm }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async (format) => {
    setIsLoading(true);
    try {
      // Call backend API with format and search parameters
      const params = new URLSearchParams();
      params.append('export_format', format);
      if (searchTerm?.trim()) {
        params.append('search', searchTerm.trim());
      }
      
      const url = `/demandeur/demandeurs/export/?${params.toString()}`;
      
      const response = await api.get(url, {
        responseType: 'blob'
      });
      
      // Determine content type and extension based on format
      const isExcel = format === 'excel';
      const contentType = isExcel 
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : 'text/csv;charset=utf-8;';
      const extension = isExcel ? 'xlsx' : 'csv';
      
      // Create download link
      const blob = new Blob([response.data], { type: contentType });
      const url_download = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url_download;
      link.setAttribute('download', `demandeurs_${new Date().toISOString().split('T')[0]}.${extension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url_download);
      
      toast.success(`Export ${format.toUpperCase()} réussi !`);
    } catch (error) {
      console.error('Erreur lors de l\'export:', error);
      if (error.response?.status === 403) {
        toast.error('Accès réservé aux administrateurs.');
      } else if (error.response?.status === 404) {
        toast.error('Endpoint d\'export introuvable.');
      } else {
        toast.error('Erreur lors de l\'export.');
      }
    } finally {
      setIsLoading(false);
      setShowExportOptions(false);
    }
  };

  return (
    <div className="relative">
      <button 
        className="px-4 py-2 bg-orange-500 text-white rounded-lg flex items-center hover:bg-orange-600 disabled:opacity-50"
        onClick={() => setShowExportOptions(!showExportOptions)}
        disabled={isLoading}
      >
        {isLoading ? (
          <Loader2 className="h-5 w-5 mr-2 animate-spin" />
        ) : (
          <Download className="h-5 w-5 mr-2" />
        )}
        {isLoading ? 'Export...' : 'Exporter'}
      </button>
      
      {showExportOptions && !isLoading && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg z-10">
          <button 
            className="w-full px-4 py-3 text-left flex items-center hover:bg-gray-100 text-gray-700 rounded-t-lg"
            onClick={() => handleExport('excel')}
          >
            <FileSpreadsheet className="h-5 w-5 mr-2 text-green-600" />
            Format Excel (.xls)
          </button>
          <button 
            className="w-full px-4 py-3 text-left flex items-center hover:bg-gray-100 text-gray-700 rounded-b-lg"
            onClick={() => handleExport('csv')}
          >
            <FileTextIcon className="h-5 w-5 mr-2 text-blue-600" />
            Format CSV (.csv)
          </button>
        </div>
      )}
    </div>
  );
};

export default ExportMenu;
